
import { t } from "@/plugins/i18n";
export default interface WorkflowStatus {
  name: string;
  readOnly: boolean;
  deleted: boolean;
  id: number;
}

export const workflowStatusDefaultProps: WorkflowStatus = {
  name: t("Osszes"),
  readOnly: true,
  deleted: false,
  id: 1,
};
